import React from "react";
import "./spinner.css";

export default function Loader() {
  const style = {
    position: "fixed",
    top: "50%",
    left: " 50%",
    zIndex: 66,
  };
  const overlayStyle = {
    width: "100%",
    height: "100vh",
    left: 0,
    position: "fixed",
    top: 0,
    /* background: aliceblue; */
    zIndex: 10,
    background: "rgb(237 237 237 / 60%)",
  };
  return (
    <>
      <div className="overlay" style={overlayStyle}></div>
      <div style={style} className="spinner-container">
        <div className="loading-spinner"></div>
      </div>
    </>
  );
}
